import { Container, Tab } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

import { PageLayout } from '../../pages/PageLayout';
import MobileNavBar from '../bars/MobileNavBar';
import MobileSwipeableView from '../views/MobileSwipeableView';
import { MobileBottomBar } from '../bars/MobileBottomBar';

/**
 * Provides a consistent layout structure for mobile. where each child is rendered
 * as a new swipeable view with a labelled tab.
 *
 * @component
 * @param {Object} props - The properties for the PageLayout component.
 * @param {React.ReactNode} props.children - The main content to be rendered within the layout.
 * @returns {React.ReactElement} Returns the layout structure containing the provided content.
 */
export const MobileLayout = ({ labels, mobileTab, setMobileTab, children }) => {
    const childrenArr = React.Children.toArray(children);
    return (
        <PageLayout>
            <Container
                sx={{
                    paddingRight: { xs: 0, sm: 11 },
                    paddingLeft: { xs: 0, sm: 4 },
                    marginTop: { xs: 10, sm: 9 }
                }}
                style={{
                    minHeight: '85vh',
                    maxWidth: '1300px'
                }}
            >
                {/*Render tabs for mobile*/}
                <MobileNavBar mobileTab={mobileTab} setMobileTab={setMobileTab}>
                    {labels.map((label) => (
                        <Tab key={label} label={label} />
                    ))}
                </MobileNavBar>
                <MobileSwipeableView
                    mobileTab={mobileTab}
                    setMobileTab={setMobileTab}
                >
                    {childrenArr}
                </MobileSwipeableView>
                <MobileBottomBar />
            </Container>
        </PageLayout>
    );
};

MobileLayout.propTypes = {
    children: PropTypes.arrayOf(PropTypes.node.isRequired).isRequired,
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
    mobileTab: PropTypes.number.isRequired,
    setMobileTab: PropTypes.func.isRequired
};
